import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { manifestActions } from "../_actions";
import { config, authHeader } from "../_helpers";
import CustomToolTip from "../_components/CustomToolTip/CustomToolTip";
import PropTypes from "prop-types";
import ReactModal from 'react-modal';
import { resourceService, manifestService } from "../_services";
import { toast } from "react-toastify";
import "./ListManifests.css";

const RESOURCE_ORDER_FILE_TYPE = {
  CREATE_FORM: 1,
  UPLOADED_FORM: 2,
};

class ListManifests extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      manifestData: [],
      manifestPage: 1,
      manifestPerPage: 15,
      totalPages: 1,
      searchTerm: "",
      viewAllFilter: "all",
      resourceName: "",
      loading: false,
      error: null,
      searchTimeout: null,
      action_id: "",
      viewStatus: false,
      showManifestModal: false,
      deleteManifestId: null,
      alertPop: false,
      alertHead: "",
      alertMsg: "",
      alertFunction: "",
    };

    this.manifestTableRef = React.createRef();
    this.handleSearch = this.handleSearch.bind(this);
    this.handleViewAllChange = this.handleViewAllChange.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.getManifestList = this.getManifestList.bind(this);
    this.viewAction = this.viewAction.bind(this);
    this.editManifest = this.editManifest.bind(this);
    this.printManifest = this.printManifest.bind(this);
    this.viewManifest = this.viewManifest.bind(this);
  }
  componentDidMount() {
    this.getManifestList();
    this.getResourceName();
  }

  componentDidUpdate(prevProps) {
    // Update manifest data when Redux state changes
    if (prevProps.manifest !== this.props.manifest) {
      const { ManifestListV1 } = this.props.manifest;


      // Handle the V1 API response structure: { status: 'success', data: { data: [...], pagination: {...}, resource_info: {...}, summary: {...} } }
      if (
        ManifestListV1 &&
        ManifestListV1.data &&
        ManifestListV1.data.data &&
        Array.isArray(ManifestListV1.data.data)
      ) {
        const totalPages = ManifestListV1.data.pagination?.last_page || 1;
        this.setState({
          manifestData: ManifestListV1.data.data,
          totalPages: totalPages,
          loading: false,
          error: null,
        });
      } else if (
        ManifestListV1 &&
        ManifestListV1.data &&
        Array.isArray(ManifestListV1.data)
      ) {
        // Fallback: direct data array
        const totalPages = ManifestListV1.pagination?.last_page || 1;
        this.setState({
          manifestData: ManifestListV1.data,
          totalPages: totalPages,
          loading: false,
          error: null,
        });
      }
    }
  }

  componentWillUnmount() {
    // Clear search timeout to prevent memory leaks
    if (this.state.searchTimeout) {
      clearTimeout(this.state.searchTimeout);
    }
  }

  getResourceName() {
    // Get resource name from props or API
    if (this.props.props && this.props.props.resource_name) {
      this.setState({ resourceName: this.props.props.resource_name });
    } else if (this.props.resourceId) {
      // Fetch resource details from API
      resourceService.getResourceDetails(this.props.resourceId)
        .then(response => {
          if (response && response.data && response.data.resource_name) {
            this.setState({ resourceName: response.data.resource_name });
          }
        })
        .catch(error => {
          console.error('Error fetching resource name:', error);
          // Fallback to default name
          this.setState({ resourceName: 'Resource' });
        });
    }
  }

  getManifestList = (manifestPageNum = 1) => {
    const data = {
      resourceId: parseInt(this.props.resourceId),
      perPage: this.state.manifestPerPage,
      page: manifestPageNum,
    };

    // Add incidentName to the request if search term exists
    if (this.state.searchTerm && this.state.searchTerm.trim() !== "") {
      data.incidentName = this.state.searchTerm.trim();
    }

    // Add manifestAvailabilityStatus to the request if filter is not "all"
    if (this.state.viewAllFilter && this.state.viewAllFilter !== "all") {
      data.manifestAvailabilityStatus = this.state.viewAllFilter;
    }

    this.props.dispatch(manifestActions.manifestListV1(data));
  };

  handleSearch = (event) => {
    const searchTerm = event.target.value;
    this.setState({ searchTerm });

    // Clear existing timeout
    if (this.state.searchTimeout) {
      clearTimeout(this.state.searchTimeout);
    }

    // Set new timeout for debounced search
    const timeout = setTimeout(() => {
      this.getManifestList(1); // Reset to page 1 when searching
    }, 500); // 500ms delay

    this.setState({ searchTimeout: timeout });
  };

  handleViewAllChange = (event) => {
    const filter = event.target.value;
    this.setState({ viewAllFilter: filter }, () => {
      // Trigger API call with new filter
      this.getManifestList(1); // Reset to page 1 when filter changes
    });
  };

  handlePageChange = (newPage) => {
    this.setState({ manifestPage: newPage }, () => {
      this.getManifestList(newPage);
      // Scroll to top of manifest table
      if (this.manifestTableRef.current) {
        this.manifestTableRef.current.scrollIntoView({ 
          behavior: 'smooth', 
          block: 'start' 
        });
      }
    });
  };

  formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    });
  };

  formatDateTime = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  viewAction = (id) => {
    this.setState({
      action_id: id,
      viewStatus: !this.state.viewStatus,
    });
  };

  editManifest = (id, baseManifestId) => {
    this.props.editManifest(id, baseManifestId);
  };

  printManifest = (id) => {
    var data =
      '?manifest_id=' +
      id +
      '&resource_id=' +
      this.props.resourceId;
    const requestOptions = {
      method: 'POST',
      headers: authHeader(),
    };
    var self = this;
    fetch(config.apiUrl + '/api/manifest/pdf' + data, requestOptions)
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (data.success) {
          const pdfLink = data.data;
          var link = document.createElement('a');
          if (
            window.navigator.userAgent.match(/iPad/i) ||
            window.navigator.userAgent.match(/iPhone/i)
          ) {
            link.href = pdfLink;
          } else {
            link.href = pdfLink;
            link.target = '_blank';
          }
          document.body.appendChild(link);
          link.click();
          setTimeout(function () {
            document.body.removeChild(link);
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(pdfLink);
          }, 100);
        } else {
          self.setState({
            alertPop: true,
            alertHead: 'Error',
            alertMsg: data.message,
            alertFunction: '',
          });
        }
      });
  };

  viewManifest = (id, baseManifestId) => {
    this.props.viewManifest(id, baseManifestId.toString());
  };

  handleViewResourceOrderForm(manifest) {
    try {
      const resourceOrderFormType = manifest.resourceOrderFormType || manifest.resource_order_form_type;
      const resourceOrderForm = manifest.resourceOrderForm || manifest.resource_order_form;
      
      switch (resourceOrderFormType) {
        case RESOURCE_ORDER_FILE_TYPE?.UPLOADED_FORM:
          if (resourceOrderForm) {
            window.open(resourceOrderForm, '_blank').focus();
          } else {
            toast.error('Resource order form file not found');
          }
          break;
        case RESOURCE_ORDER_FILE_TYPE?.CREATE_FORM:
          this.printResourceOrderForm(manifest);
          break;
        default:
          // Try to handle as UPLOADED_FORM if resourceOrderForm exists
          if (resourceOrderForm) {
            window.open(resourceOrderForm, '_blank').focus();
          } else {
            console.warn('Unknown resource order form type:', resourceOrderFormType);
            toast.error('Unable to view resource order form');
          }
          break;
      }
    } catch (error) {
      console.error('Error viewing resource order form:', error);
      toast.error('Error viewing resource order form');
    }
  }

  printResourceOrderForm(manifest) {
    try {
      let data = new FormData();
      const manifestId = manifest.manifestId || manifest.manifest_id || manifest.mid;
      data.append('manifest_id', manifestId);
      
      manifestService
        ?.viewCreatedResourceOrderForm(data)
        .then((response) => {
          this?.redirectToPdf(response);
        })
        .catch((error) => {
          console.error('Error fetching resource order form:', error);
          toast.error('Error loading resource order form');
        });
    } catch (error) {
      console.error('Error in printResourceOrderForm:', error);
      toast.error('Error generating resource order form');
    }
  }

  redirectToPdf = (data) => {
    if (data?.success) {
      const pdfLink = data.data;
      var link = document.createElement('a');
      if (
        window.navigator.userAgent.match(/iPad/i) ||
        window.navigator.userAgent.match(/iPhone/i)
      ) {
        link.href = pdfLink;
      } else {
        link.href = pdfLink;
        link.target = '_blank';
      }
      document.body.appendChild(link);
      link.click();
      setTimeout(function () {
        document.body.removeChild(link);
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(pdfLink);
      }, 100);
    }
  };

  deleteCloseModal = () => {
    this.setState({ showManifestModal: false, deleteManifestId: null });
  };

  deleteManifest = async () => {
    let data = new FormData();
    data.append('manifest_id', this.state.deleteManifestId);
    let data2 = new FormData();
    data2.append('resource_id', this.props.resourceId);
    await this.props.dispatch(manifestActions.deleteManifest(data, data2));
    this.getManifestList(); // Refresh the manifest list
    this.setState({ showManifestModal: false, deleteManifestId: null });
  };

  renderManifestRows = () => {
    const { manifestData } = this.state;

    // Ensure manifestData is an array
    let manifests = Array.isArray(manifestData) ? manifestData : [];


    // If we have no data, show a simple test row
    if (manifests.length === 0) {
      return <div> No manifests found </div>;
    }

    // If we have data but it's not in the expected format, render it directly
    if (
      manifests.length > 0 &&
      !manifests[0].contract_number &&
      !manifests[0].abbreviation
    ) {
      return manifests.map((manifest, index) => (
        <div className='manifest_items' key={`raw-${index}`}>
          <div className='employee_item_listing'>
            <div className='list_item_manifest'>
              {manifest.abbreviation || manifest.contract_type || "N/A"}
            </div>
            <div className='list_item_manifest'>
              {manifest.contract_number || manifest.contractNumber || "N/A"}
            </div>
            <div className='list_item_manifest'>
              <div className='incident_name_wrapper'>
                <div className='incident_name'>
                  {manifest.incident_name || manifest.incidentName || "N/A"}
                </div>
                <CustomToolTip label='In Use' customClass={"fs-tooltip"}>
                  <div className='status-dot status-dot-grey'></div>
                </CustomToolTip>
              </div>
            </div>
            <div className='list_item_manifest'>
              {manifest.resource_name || manifest.resourceNumber || "N/A"}
            </div>
            <div className='list_item_manifest'>
              {manifest.resource_order_form_exists === 1 && manifest.resource_order_name ? (
                <CustomToolTip
                  label={manifest.resource_order_name}
                  customClass={"fs-tooltip"}
                >
                  <a 
                    href='#' 
                    className='view-ro-link'
                    style={{ cursor: 'pointer' }}
                    onClick={(e) => {
                      e.preventDefault();
                      this.handleViewResourceOrderForm(manifest);
                    }}
                  >
                    View RO
                  </a>
                </CustomToolTip>
              ) : (
                "-"
              )}
            </div>
            <div className='list_item_manifest'>
              {manifest.added_date || "N/A"}
            </div>
            <div className='list_item_manifest'>
              {manifest.date_assigned || "N/A"}
            </div>
            <div className='list_item_manifest version-column'>
              <div className='version-item latest-version'>
                <div className='version-date-time'>
                  {manifest.added_date || "N/A"}
                </div>
                <div className='latest-label'>Latest version</div>
                <div className='version-user'>
                  {manifest.created_by_user_name || "Unknown"}
                </div>
              </div>
            </div>
            <div className='list_item action_icon'>
              <div className='action-menu'>
                <span className='action-dots'>⋮</span>
              </div>
            </div>
          </div>
        </div>
      ));
    }

    // Group manifests by their core details and sort by latest version date (same as ResourceDetails.jsx)
    const groupedManifests = manifests.reduce((groups, item) => {
      const key = `${item.manifest_id}_${item.abbreviation}_${item.contract_number}_${item.incident_name}_${item.resource_name}`;
      if (!groups[key]) {
        groups[key] = {
          manifestId: item.manifest_id || item.mid,
          abbreviation: item.abbreviation || "",
          contractNumber: item.contract_number || "-",
          incidentName: item.incident_name || "",
          resourceNumber: item.resource_number || "",
          addedDate: item.added_date || "",
          dateAssigned: item.date_assigned || "",
          resourceOrderFormExists: item.resource_order_form_exists,
          resourceOrderName: item.resource_order_name,
          assignmentStatus: item.assignment_status,
          manifestAvailability: item.manifest_availability,
          baseManifestId: item.bid || item.base_manifest_id,
          hasLatestVersion: item.has_latest_version,
          resourceOrderFormType: item.resource_order_form_type,
          resourceOrderForm: item.resource_order_form,
          versions: [],
        };
      }

      // Add versions to this manifest group
      if (item.versions && item.versions.length > 0) {
        groups[key].versions.push(...item.versions);
      }

      return groups;
    }, {});

    const manifestsOption = [];

    // Convert to array and sort by latest version date (descending) - same as ResourceDetails.jsx
    const sortedManifests = Object.values(groupedManifests).sort((a, b) => {
      const aLatestVersion =
        a.versions.find((v) => v.latest_version) || a.versions[0];
      const bLatestVersion =
        b.versions.find((v) => v.latest_version) || b.versions[0];

      if (!aLatestVersion && !bLatestVersion) return 0;
      if (!aLatestVersion) return 1;
      if (!bLatestVersion) return -1;

      return (
        new Date(bLatestVersion.added_date) -
        new Date(aLatestVersion.added_date)
      );
    });

    const allRows = [];

    sortedManifests.forEach((manifest, manifestIndex) => {
      // Sort versions within each manifest (latest first)
      const sortedVersions = manifest.versions.sort((a, b) => {
        return new Date(b.added_date) - new Date(a.added_date);
      });

      // First row: Latest manifest with full action menu
      const latestVersion = sortedVersions[0];
      allRows.push(
        <React.Fragment key={`${manifest.manifestId}-latest`}>
          <div className='employee_item latest-version-row'>
            <div className='list_item'>{manifest.abbreviation}</div>
            <div className='list_item'>{manifest.contractNumber}</div>
            <div className='list_item'>
              <div className='incident_name_wrapper'>
                <div className='incident_name'>{manifest.incidentName}</div>
                {manifest.manifestAvailability === "inuse" ||
                manifest.manifestAvailability === "closedout" ? (
                  <CustomToolTip
                    label={
                      manifest.manifestAvailability === "inuse"
                        ? "In Use"
                        : "Closed Out"
                    }
                    customClass={"fs-tooltip"}
                  >
                    <span
                      className={`status-dot ${manifest.manifestAvailability === "inuse" ? "status-dot-grey" : "status-dot-red"}`}
                    ></span>
                  </CustomToolTip>
                ) : null}
              </div>
            </div>
            <div className='list_item'>{manifest.resourceNumber}</div>
            <div className='list_item'>
              {manifest.resourceOrderFormExists === 1 &&
              manifest.resourceOrderName ? (
                <CustomToolTip
                  label={manifest.resourceOrderName}
                  customClass={"fs-tooltip"}
                >
                  <a 
                    className='' 
                    style={{ cursor: "pointer" }} 
                    href='#'
                    onClick={(e) => {
                      e.preventDefault();
                      this.handleViewResourceOrderForm(manifest);
                    }}
                  >
                    View RO
                  </a>
                </CustomToolTip>
              ) : (
                "-"
              )}
            </div>
            <div className='list_item'>
              {this.formatDate(manifest.addedDate)}
            </div>
            <div className='list_item'>
              {manifest.dateAssigned
                ? this.formatDate(manifest.dateAssigned)
                : "-"}
            </div>
            <div className='list_item'>
              <div className='version-item latest-version'>
                <div className='version-date-time'>
                  {latestVersion.added_date}
                </div>
                <div className='latest-label'>Latest version</div>
                <div className='version-user'>
                  {latestVersion.created_by_user_name}
                </div>
              </div>
            </div>
            <div
              className='list_item action_icon'
              onClick={() => this.viewAction(`${manifest.manifestId}-latest`)}
            ></div>
          </div>
          {this.state.action_id === `${manifest.manifestId}-latest` && (
            <div
              className={
                this.state.viewStatus ? "action_list" : "action_list hide"
              }
            >
              <p
                onClick={() =>
                  this.editManifest(
                    manifest.manifestId,
                    manifest.baseManifestId,
                  )
                }
              >
                Edit
              </p>
              <p onClick={() => this.printManifest(manifest.manifestId)}>
                Print
              </p>
              <p
                onClick={() =>
                  this.viewManifest(
                    manifest.manifestId,
                    manifest.baseManifestId,
                  )
                }
              >
                View
              </p>
              <p
                onClick={() =>
                  this.setState({
                    showManifestModal: true,
                    deleteManifestId: manifest.manifestId,
                  })
                }
              >
                Delete
              </p>
            </div>
          )}
        </React.Fragment>,
      );

      // Additional rows: Older versions with limited action menu
      if (sortedVersions.length > 1) {
        sortedVersions.slice(1).forEach((version, versionIndex) => {
          allRows.push(
            <React.Fragment
              key={`${manifest.manifestId}-${version.id || versionIndex}`}
            >
              <div className='employee_item old-version-row'>
                <div className='list_item'>{manifest.abbreviation}</div>
                <div className='list_item'>{manifest.contractNumber}</div>
                <div className='list_item'>
                  <div className='incident_name_wrapper'>
                    <div className='incident_name'>{manifest.incidentName}</div>
                    {manifest.manifestAvailability === "inuse" ||
                    manifest.manifestAvailability === "closedout" ? (
                      <CustomToolTip
                        label={
                          manifest.manifestAvailability === "inuse"
                            ? "In Use"
                            : "Closed Out"
                        }
                        customClass={"fs-tooltip"}
                      >
                        <span
                          className={`status-dot ${manifest.manifestAvailability === "inuse" ? "status-dot-grey" : "status-dot-red"}`}
                        ></span>
                      </CustomToolTip>
                    ) : null}
                  </div>
                </div>
                <div className='list_item'>{manifest.resourceNumber}</div>
                <div className='list_item'>
                  {manifest.resourceOrderFormExists === 1 &&
                  manifest.resourceOrderName ? (
                    <CustomToolTip
                      label={manifest.resourceOrderName}
                      customClass={"fs-tooltip"}
                    >
                      <a 
                        className='' 
                        style={{ cursor: "pointer"}} 
                        href='#'
                        onClick={(e) => {
                          e.preventDefault();
                          this.handleViewResourceOrderForm(manifest);
                        }}
                      >
                        View RO
                      </a>
                    </CustomToolTip>
                  ) : (
                    "-"
                  )}
                </div>
                <div className='list_item'>
                  {this.formatDate(manifest.addedDate)}
                </div>
                <div className='list_item'>
                  {manifest.dateAssigned
                    ? this.formatDate(manifest.dateAssigned)
                    : "-"}
                </div>
                <div className='list_item version-column'>
                  <div className='version-item old-version'>
                    <div className='version-date-time'>
                      {version.added_date}
                    </div>
                    <div className='version-user'>
                      {version.created_by_user_name}
                    </div>
                  </div>
                </div>
                <div
                  className='list_item action_icon'
                  onClick={() =>
                    this.viewAction(
                      `${manifest.manifestId}-${version.id || versionIndex}`,
                    )
                  }
                ></div>
              </div>
              {this.state.action_id ===
                `${manifest.manifestId}-${version.id || versionIndex}` && (
                <div
                  className={
                    this.state.viewStatus ? "action_list" : "action_list hide"
                  }
                >
                  <p onClick={() => this.printManifest(manifest.manifestId)}>
                    Print
                  </p>
                  <p
                    onClick={() =>
                      this.viewManifest(
                        manifest.manifestId,
                        manifest.baseManifestId,
                      )
                    }
                  >
                    View
                  </p>
                </div>
              )}
            </React.Fragment>,
          );
        });
      }
    });

    // Wrap all rows in manifest_items container
    if (allRows.length > 0) {
      manifestsOption.push(
        <div className='manifest_items' key='all-manifests-wrapper'>
          {allRows}
        </div>,
      );
    }

    return manifestsOption;
  };

  renderMobileManifestCards = () => {
    const { manifestData } = this.state;
    let manifests = Array.isArray(manifestData) ? manifestData : [];

    if (manifests.length === 0) {
      return null;
    }

    // Group manifests same as desktop
    const groupedManifests = manifests.reduce((groups, item) => {
      const key = `${item.manifest_id}_${item.abbreviation}_${item.contract_number}_${item.incident_name}_${item.resource_name}`;
      if (!groups[key]) {
        groups[key] = {
          manifestId: item.manifest_id || item.mid,
          abbreviation: item.abbreviation || "",
          contractNumber: item.contract_number || "-",
          incidentName: item.incident_name || "",
          resourceNumber: item.resource_name || "",
          addedDate: item.added_date || "",
          dateAssigned: item.date_assigned || "",
          resourceOrderFormExists: item.resource_order_form_exists,
          resourceOrderName: item.resource_order_name,
          assignmentStatus: item.assignment_status,
          manifestAvailability: item.manifest_availability,
          baseManifestId: item.bid || item.base_manifest_id,
          hasLatestVersion: item.has_latest_version,
          resourceOrderFormType: item.resource_order_form_type,
          resourceOrderForm: item.resource_order_form,
          versions: [],
        };
      }

      if (item.versions && item.versions.length > 0) {
        groups[key].versions.push(...item.versions);
      }

      return groups;
    }, {});

    const sortedManifests = Object.values(groupedManifests).sort((a, b) => {
      const aLatestVersion =
        a.versions.find((v) => v.latest_version) || a.versions[0];
      const bLatestVersion =
        b.versions.find((v) => v.latest_version) || b.versions[0];

      if (!aLatestVersion && !bLatestVersion) return 0;
      if (!aLatestVersion) return 1;
      if (!bLatestVersion) return -1;

      return (
        new Date(bLatestVersion.added_date) -
        new Date(aLatestVersion.added_date)
      );
    });

    return (
      <div className='for_mobile_manifest_list'>
        {sortedManifests.map((manifest, index) => (
          <React.Fragment key={index}>
            <hr />
            <div className='manifest_items'>
              <div className='status_item'>
                <div className='list_item'>
                  <strong>Contract Type</strong>
                </div>
                <div className='list_item'>{manifest.abbreviation || "-"}</div>
              </div>
              <div className='status_item'>
                <div className='list_item'>
                  <strong>Contract Number</strong>
                </div>
                <div className='list_item'>
                  {manifest.contractNumber || "-"}
                </div>
              </div>
              <div className='status_item'>
                <div className='list_item'>
                  <strong>Incident Name</strong>
                </div>
                <div className='list_item'>{manifest.incidentName || "-"}</div>
              </div>
              <div className='status_item'>
                <div className='list_item'>
                  <strong>Resource Number</strong>
                </div>
                <div className='list_item'>
                  {manifest.resourceNumber || "-"}
                </div>
              </div>
              <div className='status_item'>
                <div className='list_item'>
                  <strong>RO</strong>
                </div>
                <div className='list_item'>
                  {manifest.resourceOrderName || "-"}
                </div>
              </div>
              <div className='status_item'>
                <div className='list_item'>
                  <strong>Date Added</strong>
                </div>
                <div className='list_item'>
                  {manifest.addedDate
                    ? this.formatDate(manifest.addedDate)
                    : "-"}
                </div>
              </div>
              <div className='status_item'>
                <div className='list_item'>
                  <strong>Date Assigned</strong>
                </div>
                <div className='list_item'>
                  {manifest.dateAssigned
                    ? this.formatDate(manifest.dateAssigned)
                    : "-"}
                </div>
              </div>
              <div className='status_item'>
                <div className='list_item'>
                  <strong>Version</strong>
                </div>
                <div className='list_item'>Latest</div>
              </div>
              <div className='status_item mobile_action_row'>
                <div
                  className='list_item action_icon mobile_action_icon'
                  onClick={() =>
                    this.viewAction(`${manifest.manifestId}-latest-mobile`)
                  }
                ></div>
              </div>
            </div>
            {this.state.action_id ===
              `${manifest.manifestId}-latest-mobile` && (
              <div
                className={
                  this.state.viewStatus ? "action_list" : "action_list hide"
                }
              >
                <p
                  onClick={() =>
                    this.editManifest(
                      manifest.manifestId,
                      manifest.baseManifestId,
                    )
                  }
                >
                  Edit
                </p>
                <p onClick={() => this.printManifest(manifest.manifestId)}>
                  Print
                </p>
                <p
                  onClick={() =>
                    this.setState({
                      showManifestModal: true,
                      deleteManifestId: manifest.manifestId,
                    })
                  }
                >
                  Delete
                </p>
                <p
                  onClick={() =>
                    this.viewManifest(
                      manifest.manifestId,
                      manifest.baseManifestId,
                    )
                  }
                >
                  View
                </p>
              </div>
            )}
          </React.Fragment>
        ))}
        {this.renderPagination()}
      </div>
    );
  };

  renderPagination = () => {
    const { manifestPage, totalPages } = this.state;


    if (totalPages <= 1) {
      return null;
    }

    let pages = [];
    let currentPage = manifestPage;
    let startingIndex = currentPage - 2 > 0 ? currentPage - 2 : 1;
    let lastPageIndex =
      currentPage + 2 < totalPages ? currentPage + 2 : totalPages;
    let nextPage = currentPage + 1 > totalPages ? totalPages : currentPage + 1;
    let prevPage = currentPage - 1 > 0 ? currentPage - 1 : 1;

    // First page with ellipsis
    if (currentPage > 3) {
      pages.push(
        <li
          className='inactive'
          key={0}
          onClick={() => {
            this.handlePageChange(1);
          }}
        >
          <a>1</a>
        </li>,
      );
    }
    if (currentPage > 4) {
      pages.push(
        <li className='inactive' key={totalPages + 1}>
          <a>. . .</a>
        </li>,
      );
    }

    // Page numbers
    for (let i = startingIndex; i <= lastPageIndex; i++) {
      pages.push(
        <li
          className={i == currentPage ? "active" : "inactive"}
          key={i}
          onClick={() => {
            this.handlePageChange(i);
          }}
        >
          <a>{i}</a>
        </li>,
      );
    }

    // Last page with ellipsis
    if (lastPageIndex + 1 < totalPages) {
      pages.push(
        <li className='inactive' key={totalPages + 1}>
          <a>. . .</a>
        </li>,
      );
    }
    if (lastPageIndex < totalPages) {
      pages.push(
        <li
          className='inactive'
          key={totalPages}
          onClick={() => {
            this.handlePageChange(totalPages);
          }}
        >
          <a>{totalPages}</a>
        </li>,
      );
    }

    if (pages?.length > 0) {
      return (
        <div
          className='fs-pagination-wrapper-outer custome_old_pagination'
          key={7}
        >
          <div className='fs-pagination-wrapper'>
            <span
              className={`prev ${
                prevPage === 1 && currentPage === 1 ? "disabled" : ""
              }`}
              onClick={() => {
                this.handlePageChange(prevPage);
              }}
            >
              <img
                alt='previous'
                src={require("../assets/icons/next_arrow.svg").default}
              />
            </span>
            <ul className='fs-pagination'>{pages}</ul>
            <span
              className={`next ${nextPage == totalPages ? "disabled" : ""}`}
              onClick={() => {
                this.handlePageChange(nextPage);
              }}
            >
              <img
                alt='next'
                src={require("../assets/icons/next_arrow.svg").default}
              />
            </span>
          </div>
        </div>
      );
    }

    return null;
  };

  render() {
    const { resourceName, searchTerm, viewAllFilter } = this.state;
    const { loading } = this.props.manifest;

    return (
      <div className='resource_container resource_details'>
        <div className='breadcrumbs'>
          <Link className='green' to='/resources'>
            Resources
          </Link>{" "}
          / {resourceName || "-"} / Manifests
        </div>

        <div className='page_title' ref={this.manifestTableRef}>
          <h1>Manifests</h1>
        </div>

        <div className='manifest_controls'>
          <div className='view_all_dropdown'>
            <select
              id='viewAllFilter'
              name='viewAllFilter'
              value={viewAllFilter}
              onChange={this.handleViewAllChange}
              className='view_all_select'
            >
              <option value='all'>View All</option>
              <option value='inuse'>In Use</option>
              <option value='closedout'>Closed Out</option>
            </select>
          </div>

          <div className='search_field'>
            <input
              type='text'
              id='searchTerm'
              name='searchTerm'
              placeholder='Search by incident name or resource number...'
              value={searchTerm}
              onChange={this.handleSearch}
              className='search_input'
            />
          </div>
        </div>

        <div className='mobile_hide_list_manifests'>
          <div className='manifest_list outer_list'>
            <div className='list_header'>
              <div className='list_item_head'>Contract Type</div>
              <div className='list_item_head'>Contract Number</div>
              <div className='list_item_head'>Incident Name</div>
              <div className='list_item_head'>Resource Number</div>
              <div className='list_item_head'>RO</div>
              <div className='list_item_head'>Date Added</div>
              <div className='list_item_head'>Date Assigned</div>
              <div className='list_item_head'>Version</div>
              <div className='list_item_head' />
            </div>

            {loading ? (
              <div className='loading'>Loading...</div>
            ) : (
              <>
                {this.renderManifestRows()}
                {this.renderPagination()}
              </>
            )}
          </div>
        </div>
        {this.renderMobileManifestCards()}
        
        {/* Delete Manifest Modal */}
        <ReactModal
          isOpen={this.state.showManifestModal}
          onClose={this.deleteCloseModal}
          overlayClassName='deletetPopup'
        >
          <div id='deletePopup'>
            <div className='modal-head'>
              <h4 className='modal-title'>Confirm</h4>
              <img
                alt='close'
                className='closeModal'
                onClick={this.deleteCloseModal}
                src={require('../assets/images/close_green.png').default}
              />
            </div>
            <div className='modal-body'>
              <div className='status_step step1'>
                <label>
                  Do you really want to remove this manifest? Doing so will
                  remove the assignment history and modify the employees' fire
                  records.
                </label>
                <br />
                <div className='btn_list_popup'>
                  <button
                    className='button grey'
                    onClick={this.deleteCloseModal}
                  >
                    Cancel
                  </button>
                  <button
                    className='button'
                    onClick={this.deleteManifest}
                  >
                    OK
                  </button>
                </div>
              </div>
            </div>
          </div>
        </ReactModal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { manifest } = state;
  return { manifest };
}

const connectedListManifests = connect(mapStateToProps)(ListManifests);
export { connectedListManifests as ListManifests };

ListManifests.propTypes = {
  goBack: PropTypes.func.isRequired,
  resourceId: PropTypes.string.isRequired,
  props: PropTypes.object,
  dispatch: PropTypes.func.isRequired,
  manifest: PropTypes.object.isRequired,
  viewManifest: PropTypes.func.isRequired,
  editManifest: PropTypes.func.isRequired,
};
